export const LOCALES: Array<{ label: string; id: string; sampleBg: string }> = [
  {
    label: 'English',
    id: 'en',
    sampleBg: 'url("/static/en.svg") center / contain no-repeat',
  },
  {
    label: '日本语',
    id: 'ja',
    sampleBg: 'url("/static/ja.svg") center / contain no-repeat',
  },
  {
    label: '한국어',
    id: 'kr',
    sampleBg: 'url("/static/kr.svg") center / contain no-repeat',
  },
  {
    label: 'Русский',
    id: 'ru',
    sampleBg: 'url("/static/ru.svg") center / contain no-repeat',
  },
  {
    label: 'ไทย',
    id: 'th',
    sampleBg: 'url("/static/th.svg") center / contain no-repeat',
  },
  {
    label: 'Bahasa Indonesia',
    id: 'id',
    sampleBg: 'url("/static/id.svg") center / contain no-repeat',
  },
  {
    label: 'Tiếng Việt',
    id: 'vi',
    sampleBg: 'url("/static/vi.svg") center / contain no-repeat',
  },
  {
    label: 'Bahasa Melayu',
    id: 'ms',
    sampleBg: 'url("/static/ms.svg") center / contain no-repeat',
  },
  {
    label: '繁体中文',
    id: 'zh',
    sampleBg: 'url("/static/zh.svg") center / contain no-repeat',
  },
];
